import { loadMarches } from '@/lib/hooks';
import { useGame } from '@/store/game';
import { Button, Card, Countdown, IconButton, Panel } from '@/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function AttackIndicator() {
  const incoming = useGame((s) => s.incoming);
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (!incoming.length) return null;
  return (
    <IconButton
      icon="army"
      iconSize={22}
      badge={incoming.length}
      label={t('game:attacks.warning', { n: incoming.length })}
      className="!h-10 !w-10 mail-unread-blink"
      onClick={() => navigate('/game/mail?tab=attacks')}
    />
  );
}

export function IncomingAttacks() {
  const incoming = useGame((s) => s.incoming);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const reload = () => void loadMarches().catch(() => undefined);
  return (
    <Panel title={t('game:attacks.title')}>
      {!incoming.length ? (
        <p className="py-3 text-parchment-300">{t('game:attacks.empty')}</p>
      ) : (
        <div className="space-y-3">
          {[...incoming]
            .sort((a, b) => a.arriveAt.localeCompare(b.arriveAt))
            .map((a) => (
              <Card key={a.id} className="space-y-2 !border-blood-500 bg-blood-500/10">
                <p className="font-bold text-red-300">
                  ⚔ {t('game:attacks.from', { name: a.fromName ?? '—' })}
                </p>
                <p>
                  {a.capital
                    ? t('game:map.capital')
                    : a.keypoint
                      ? `🏯 ${t('game:outpost.keypoint')}`
                      : (a.castleName ?? '')}{' '}
                  ({a.toX}:{a.toY})
                </p>
                <p>
                  {t('game:attacks.arrival')} <Countdown to={a.arriveAt} onDone={reload} />
                </p>
                <Button variant="secondary" onClick={() => navigate(`/game/map?x=${a.toX}&y=${a.toY}`)}>
                  {t('game:attacks.onMap')}
                </Button>
              </Card>
            ))}
        </div>
      )}
    </Panel>
  );
}
